import LightTriangleReflected from "./LightTriangleReflected";

export default LightTriangleReflected;
